import React from 'react';
import OneColumn from './components/oneColumn';
import TwoColumn from './components/twoColumn';
import { toPascalCase } from '../../../../utils/utils';
import { gridType } from '../../../../types/common-types';
import './style.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TYPES: { [key: string]: React.FC<any> } = {
  OneColumn,
  TwoColumn,
};

interface GridProps {
  type: gridType;
  components: object;
}

const Grid: React.FC<GridProps> = ({ type, components }) => {
  const GridComp = TYPES[toPascalCase(type)];
  if (!GridComp) return null;
  return (
    <div styleName="grid">
      <GridComp components={components} />
    </div>
  );
};
export default Grid;
